<template lang="html">
    <vs-popup :active.sync="showPopup" :title="'MCC Id du '+ getSocietyName()">
             <!-- <vx-card class="mb-1"> -->
                <div class="note-form" style="display: flex; flex-direction: column;">
                    <label for="mccID">MCC Id <i>( Format: 123456789 )</i></label>
        <vs-input class="w-full" v-model="mccID"></vs-input>
        <vs-button ref="send-message-button" class = "mt-5" @click="addMccId" style="margin-left: auto;">Enregistrer</vs-button>
    </div>
    
             <!-- </vx-card> -->
            </vs-popup>
         </template>
    
    <script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import store from "@/store/store";
export default {
	created() {
		store.dispatch("getAllSocieties");
		this.assginMccId();
		//getting orders which belongs to user sign in
	},
	components: {},
	mounted() {},
	name: "AddMCcIdPopup",
	mixins: [dbFieldConvertor, utilsMixin],
	props: {
		popupActive: Boolean,
		mccId: {
			type: String,
			default: "",
		},
		societyId: {
			type: Number,
			default: 0,
			required: true,
		},
	},

	data() {
		return {
			// apiUrl: this.$store.state.backendApiUrl,
			mccID: "",
			showPopup: this.$props.popupActive,
		};
	},
	computed: {
		allSocieties: () => {
			return store.state.societies;
		},
		apiUrl: () => {
			return store.state.backendApiUrl;
		},
	},
	methods: {
		assginMccId: function () {
			this.mccID = this.$props.mccId;
		},
		getSocietyName: function () {
			return this.allSocieties
				.filter((ele) => ele.id == this.$props.societyId)
				.map((e) => e.name);
		},

		addMccId: function () {
			if (this.mccID.trim() === "") return;
			this.setLoading(true, "send-message-button");
			// //console.log("COMEMRCIOA", this.destinationUserId);
			let filteredMccId = this.mccID.replaceAll("-", "");
			if (!/^\d+$/.test(filteredMccId)) {
				this.$vs.notify({
					title: "Echec",
					text: "Le Mcc Id doit être un nombre.",
				});
				this.setLoading(false, "send-message-button");
				return;
			} else {
				const body = {
					mccId: filteredMccId,
					societyId: this.$props.societyId,
				};

				this.$http
					.patch(this.apiUrl + "society/mccId", body)
					.then((res) => {
						this.$vs.notify({
							title: "Succès",
							text: "Mcc Id ajouté avec succès.",
						});
						this.setLoading(false, "send-message-button");
						this.showPopup = false;
						this.$emit("close-popup");
					})
					.catch((err) => {
						this.setLoading(false, "send-message-button");
						this.$vs.notify({
							title: "Echec",
							text: "Le Mcc Id n'a pas été ajouté.",
						});
					});
			}
		},
	},
};
</script>
    